/* LIGAS buy-now (snippets/buy-buttons.liquid renders button[name="buy-now"]).
   One delegated listener for every buy-now button on the page. The old per-button listener was
   bound on DOMContentLoaded, so it died as soon as product-rerender replaced <buy-buttons> after a
   size change, and it never existed in quick-buy drawers, whose markup is injected later. */
(function () {
  'use strict';
  if (window.__ligasBuyNow) return;
  window.__ligasBuyNow = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button[name="buy-now"]');
    if (!button || !button.form) return;
    event.preventDefault();
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;

    var form = button.form;
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    var cleanup = function () {
      form.removeEventListener('variant:add', onAdd);
      form.removeEventListener('cart:error', onError);
    };
    var onAdd = function () {
      cleanup();
      var go = function () { window.location.href = root + 'checkout'; };
      // free-bag promo (snippets/ligas-free-bag.liquid): let it put the bag in the cart first, max 3 s
      if (window.ligasFreeBag && window.ligasFreeBag.ensure) {
        Promise.race([window.ligasFreeBag.ensure(), new Promise(function (r) { setTimeout(r, 3000); })]).then(go, go);
      } else {
        go();
      }
    };
    var onError = function () { cleanup(); button.removeAttribute('aria-busy'); };

    button.setAttribute('aria-busy', 'true');
    form.addEventListener('variant:add', onAdd);
    form.addEventListener('cart:error', onError);
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  });
})();
